/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeAccordion, BaSeParagraph, BaSeTheme } from '@base/react';
import React from 'react';
import {
  Container,
  ContainerText,
  Content,
  ContentDescription,
  ContentQuestions,
} from './style';
function FrequentsQuestions() {
  const frequentQuestions = [
    {
      id: 1,
      title: 'Por que participar do seminário Empretec?',
      description:
        'É comum ouvir que empresários nascem, não se fazem. Entretanto, o Sebrae tem a firme convicção de que os empresários podem ser desenvolvidos e que o potencial empresarial é uma qualidade muito comum. O Empretec é um seminário intensivo, destinado a aumentar seu potencial para gerir melhor o seu empreendimento ou para iniciar um negócio bem-sucedido. Neste programa, você aprenderá a identificar seu potencial empreendedor, desenvolver suas características de comportamento empreendedor e descobrir novas oportunidades de negócio.',
      opened: false,
    },
    {
      id: 2,
      title: 'Como me inscrever no seminário Empretec?',
      description:
        'Antes de efetuar a sua inscrição, é necessário passar por uma entrevista de seleção. Por se tratar de um seminário com ênfase comportamental, a seleção assume um papel decisivo para o êxito dos resultados. A entrevista serve para identificar o perfil empreendedor do participante e avaliar se o indivíduo está em um momento de vida (físico e psicológico) adequado que permita absorver toda a experiência e aprendizado que o evento proporciona. Caso seja aprovado, o candidato é direcionado para efetuar o pagamento da inscrição.',
      opened: false,
    },
    {
      id: 3,
      title: 'Como funciona a seleção para participar do seminário Empretec?',
      description:
        'A seleção é realizada por meio de entrevista focada, conduzida por um especialista habilitado na metodologia do Empretec. Essa etapa pode ser realizada de forma presencial ou à distância, com duração média de 50 minutos. O resultado da entrevista serve como instrumento de trabalho para o participante e para a equipe que conduzirá as atividades durante o seminário.',
      opened: false,
    },
    {
      id: 4,
      title:
        'Quero participar do seminário Empretec com meu sócio. É possível?',
      description:
        'Não é recomendado que participem do mesmo seminário candidatos com relação de parentesco (cônjuges, pai/mãe e filhos), sociedade ou com funções hierárquicas diferentes em uma mesma organização para não haver prejuízo na autoexposição (fundamental nas atividades realizadas durante o seminário Empretec) e comprometer o aprendizado.',
      opened: false,
    },
    {
      id: 5,
      title:
        'Se eu não for aprovado no processo de seleção, poderei participar novamente depois de quanto tempo?',
      description:
        'Depende de cada caso. O tempo recomendado para participar novamente da entrevista, caso não seja aprovado no primeiro momento, é orientado pelo selecionador, ao final da entrevista, e varia de participante para participante.',
      opened: false,
    },
    {
      id: 6,
      title: 'Por quanto tempo a entrevista é válida?',
      description:
        'Caso seja aprovado, a entrevista focada no candidato terá validade de 6 meses.',
      opened: false,
    },
    {
      id: 7,
      title: 'Por quanto tempo dura a entrevista?',
      description: 'Em média 50 minutos.',
      opened: false,
    },
  ];
  const [options, setOptions] = React.useState(frequentQuestions);

  const handleClick = (id) => {
    setOptions((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        opened: item.id === id,
      })),
    );
  };
  return (
    <Container id="5">
      <ContainerText>
        <ContainerText>
          <p>
            <strong>Perguntas</strong> frequentes
          </p>
        </ContainerText>
      </ContainerText>

      <Content>
        {options.map((question) => (
          <ContentQuestions key={question.id}>
            <BaSeAccordion
              backgroundContentColor="#0000C9"
              backgroundTitleColor="#0000C9"
              borderTitleColor="#0000C9"
              onOpenIndexChange={() => {
                if (question.opened) {
                  setOptions(frequentQuestions);
                } else {
                  handleClick(question.id);
                }
              }}
              shadow="0"
              startOpen={question.opened ? 0 : undefined}
              options={[
                {
                  content: (
                    <ContentDescription>
                      <BaSeParagraph
                        color={BaSeTheme.colors.defaultColors.white}
                      >
                        {question.description}
                      </BaSeParagraph>
                    </ContentDescription>
                  ),
                  title: `${question.title}`,
                },
              ]}
              radius={30}
              titleColor="#ffffff"
            />
          </ContentQuestions>
        ))}
      </Content>
    </Container>
  );
}

export default FrequentsQuestions;
